module.exports = __webpack_public_path__ + "img/coin.3952e115.png";